<div class="container-fluid">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
</div>